<template>
    <div class="bottom-slot-action-bar">
        <div class="bottom-slot-action-bar__wrap" :class="{ 'bottom-slot-action-bar__wrap--column': isColumn }">
            <slot name="additional"></slot>
            <DsButton
                v-if="props.hasBtnClose"
                :icon-left="props.buttonCloseIcon ? props.buttonCloseIcon.iconLeft : undefined"
                :icon-right="props.buttonCloseIcon ? props.buttonCloseIcon.iconRight : undefined"
                :is-in-story-book="props.isInStorybook"
                :is-disabled="props.buttonsDisabled"
                :type="btnCloseType"
                @click="modalClose"
                :data-test="btnCloseDataTest"
                :theme="theme"
                :size="size"
            >
                {{ btnCloseText }}
            </DsButton>
            <DsButton
                v-if="props.hasBtnSubmit"
                :is-disabled="props.buttonsDisabled"
                :type="btnSubmitType"
                @click="submitDialog"
                :icon-left="props.buttonSubmitIcon ? props.buttonSubmitIcon.iconLeft : undefined"
                :icon-right="props.buttonSubmitIcon ? props.buttonSubmitIcon.iconRight : undefined"
                :is-in-story-book="props.isInStorybook"
                :data-test="btnSubmitDataTest"
                :theme="theme"
                :size="size"
            >
                {{ btnSubmitText }}
            </DsButton>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { inject } from "vue";
import { isModalVisibleInjectionKey } from "../modal-dialog/ds-modal-dialog-injection-key";
import DsButton from "../button/ds-button.vue";
import type { SvgIcons } from "../icon/types";
import { Theme } from "../types/theme";
import { Size } from "../types/size";
import { ButtonType } from "../types/button";

type IconType = {
    iconLeft?: SvgIcons;
    iconRight?: SvgIcons;
};

const props = withDefaults(
    defineProps<{
        /**
         * Show / Hide submit btn
         */
        hasBtnSubmit?: boolean;
        /**
         * Submit text
         */
        btnSubmitText?: string;
        /**
         * Submit data test
         */
        btnSubmitDataTest?: string;
        /**
         * Close text
         */
        btnCloseText?: string;
        /**
         * Close data test
         */
        btnCloseDataTest?: string;
        /**
         * Show / Hide close button
         */
        hasBtnClose?: boolean;
        /**
         * Set column variant
         */
        isColumn?: boolean;
        /**
         * Disable buttons
         */
        buttonsDisabled?: boolean;
        /**
         * Set icon for close button
         */
        buttonCloseIcon?: IconType;
        /**
         * Set icon from submit button
         */
        buttonSubmitIcon?: IconType;
        /**
         * Storybook icon path
         */
        isInStorybook?: boolean;
        /**
         * Set theme
         */
        theme?: Theme;
        /**
         * Set size
         */
        size?: Size;
        /**
         * Set type for submit button
         */
        btnSubmitType?: ButtonType;
        /**
         * Set type for close button
         */
        btnCloseType?: ButtonType;
    }>(),
    {
        hasBtnSubmit: true,
        btnSubmitText: "POTVRDIT",
        btnCloseText: "ZAVŘÍT",
        hasBtnClose: true,
        isColumn: false,
        buttonsDisabled: false,
        btnSubmitType: "primary",
        btnCloseType: "secondary",
    }
);

const isModalVisible = inject(isModalVisibleInjectionKey);

const emit = defineEmits(["submitDialog", "closeDialog"]);

const submitDialog = () => {
    emit("submitDialog", null);
};

const modalClose = () => {
    emit("closeDialog", null);
    isModalVisible.value = false;
};
</script>
